import { render, staticRenderFns } from "./summary-tab.vue?vue&type=template&id=3c22ea96"
import script from "./summary-tab.vue?vue&type=script&lang=js"
export * from "./summary-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports